import React, {useState} from 'react';
import { Link } from 'react-router-dom';
import SideBar  from '../../components/Topbar';
import { HTMLCourseNavProvider } from "../../components/SidebarCourseContext";
import { color } from 'framer-motion';
import { CopyBlock, dracula } from "react-code-blocks";


const JavaScriptLesson33 = () => {
  const [language, changeLanguage] = useState("javascript");
  const [lineNumbers, toggleLineNumbers] = useState(false);
  const code = (
  'text',
  `
  for (initialization; condition; increment/decrement) {
    // code block to be executed
  }
  `
  );
  const code2 = (
  'text',
  `
  for (let i = 0; i < 5; i++) {
  console.log("Iteration " + i);
  }
  `
  );
  const code3 = (
  'text',
  `
  while (condition) {
    // code block to be executed
  }
  `
  );
  const code4 = (
  'text',
  `
  let i = 0;
  while (i < 5) {
    console.log("Iteration " + i);
    i++;
}
  `
  );
  const code5 = (
  'text',
  `
  do {
   // code block to be executed
  } while (condition);
  `
  );
  const code6 = (
  'text',
  `
  let i = 0;
  do {
    console.log("Iteration " + i);
    i++;
  } while (i < 5);
  `
  );
  const code7 = (
  'text',
  `array.forEach(function(currentValue, index, array) {
   // Code to be executed for each element
  });`
  );
  const code8 = (
  'text',
  `let numbers = [1, 2, 3, 4, 5];
   numbers.forEach(function(number, index) {
   console.log("Element at index " + index + " is " + number);
  });`
  );
  const code9 = (
  'text',
` Element at index 0 is 1
  Element at index 1 is 2
  Element at index 2 is 3
  Element at index 3 is 4
  Element at index 4 is 5`
  );
  const code10 = (
  'text',
` let numbers = [1, 2, 3, 4, 5];
  numbers.forEach((number, index) => {
  console.log("Element at index " + index + " is " + number);
  });`
  );
  const code11 = (
  'text',
` for (variable of iterable) {
    // Code to be executed for each element
}
`
  );
  const code12 = (
  'text',
` let fruits = ['apple', 'banana', 'cherry'];
  for (let fruit of fruits) {
      console.log(fruit);
  }`
  );
  const code13 = (
  'text',
` apple
  banana
  cherry`
  );
  const code14 = (
  'text',
` let str = 'Hello';
  for (let char of str) {
      console.log(char);
  }`
  );
  const code15 = (
  'text',
` H
  e
  l
  l
  o`
  );
  const code16 = (
  'text',
` for (let i = 0; i < 10; i++) {
    if (i === 5) {
        break; // Terminate the loop when i equals 5
    }
    if (i % 2 === 0) {
        continue; // Skip even numbers
    }
    console.log("Iteration " + i);
}`
  );
  const code17 = (
  'text',
` for (let i = 0; i < 3; i++) {
    for (let j = 0; j < 2; j++) {
        console.log("i: " + i + ", j: " + j);
    }
}`
  );
  return(
    <HTMLCourseNavProvider>
    <div className="container">
    <div className="row">
    <div>
    <SideBar  />
    </div>
    <div className="col-md-12">

    <h3><strong>Loops</strong></h3>
    <p>Loops are programming structures that allow you to execute a block of code repeatedly until a specified condition is met.</p>
    <p>JavaScript provides several types of loops, each suited for different scenarios, enabling you to iterate over arrays, manipulate objects, and perform repetitive tasks efficiently. Let's explore the three main types of loops in JavaScript:</p>
    <div class="alert alert-secondary mt-3" role="alert">
    <h4><strong>1. for Loop</strong></h4>
    <p>The for loop is commonly used when you know the number of iterations required. It consists of three parts: initialization, condition, and increment/decrement.</p>
    <h5><strong>Syntax</strong></h5>
    <CopyBlock
    language={language}
    text={code}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    />
    <h5 className="mt-3"><strong>Example</strong></h5>
    <CopyBlock
    language={language}
    text={code2}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    />
    </div>

    <div class="alert alert-secondary mt-3" role="alert">
    <h4><strong>2. while Loop</strong></h4>
    <p>The while loop repeatedly executes a block of code as long as a specified condition is true. It is used when the number of iterations is not known beforehand and depends on the condition.</p>
    <h5><strong>Syntax</strong></h5>
    <CopyBlock
    language={language}
    text={code3}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    />
    <h5 className="mt-3"><strong>Example</strong></h5>
    <CopyBlock
    language={language}
    text={code4}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    />
    </div>

    <div class="alert alert-secondary mt-3" role="alert">
    <h4><strong>3. do...while Loop</strong></h4>
    <p>The do...while loop is similar to the while loop but guarantees that the code block is executed at least once before checking the condition. It continues to execute the block as long as the specified condition is true.</p>
    <h5><strong>Syntax</strong></h5>
    <CopyBlock
    language={language}
    text={code5}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    />
    <h5 className="mt-3"><strong>Example</strong></h5>
    <CopyBlock
    language={language}
    text={code6}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    />
    </div>

    <div class="alert alert-secondary mt-3" role="alert">
    <h4><strong>4. forEach() Loop</strong></h4>
    <p>forEach() loop is a higher-order function used to iterate over elements in an array or array-like object and execute a provided function once for each element.</p>
    <p>It offers a concise and expressive way to perform operations on each element of an array without needing to use traditional for loops. Let's explore how the forEach() loop works:</p>
    <h5><strong>Syntax</strong></h5>
    <CopyBlock
    language={language}
    text={code7}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    />
    <ul>
    <li>currentValue: The current element being processed in the array.</li>
    <li>index (optional): The index of the current element being processed in the array.</li>
    <li>array (optional): The array that forEach() is being called upon.</li>
    </ul>
    <h5 className="mt-3"><strong>Example</strong></h5>
    <CopyBlock
    language={language}
    text={code8}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    />
    <h5 className="mt-3"><strong>Result</strong></h5>
    <CopyBlock
    language={language}
    text={code9}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    />
    <p className="mt-3">In this example, the forEach() loop iterates over each element in the numbers array and executes the provided function for each element. The number parameter represents the current element, and the index parameter represents the index of the current element in the array.</p>
    <h5 className="mt-3"><strong>Using Arrow Function</strong></h5>
    <p>With ES6 arrow functions, the syntax can be further simplified:</p>
    <CopyBlock
    language={language}
    text={code10}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    />
    <p className="mt-3"><strong>Note</strong>: The forEach() loop is useful when you need to perform a task for each element in an array, such as printing values, updating values, or performing calculations. However, it does not support breaking out of the loop prematurely (like for loops with break statements), and it cannot be used to return a value or create a new array directly. If you need more control over the iteration process or need to transform the elements into a new array, you may consider using other array methods like map(), filter(), or traditional for loops.</p>
    </div>


    <div class="alert alert-secondary mt-3" role="alert">
    <h4><strong>5. for...of Loop</strong></h4>
    <p>for...of loop is a modern iteration feature introduced in ECMAScript 6 (ES6) that provides a convenient way to iterate over iterable objects, such as arrays, strings, maps, sets, and more.</p>
    <p>It allows you to loop through the elements of an iterable object without needing to track indices manually, making code more readable and concise. Let's explore how the for...of loop works:</p>
    <h5><strong>Syntax</strong></h5>
    <CopyBlock
    language={language}
    text={code11}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    />
    <ul>
    <li>variable: Represents the variable that will be assigned the value of each element in the iterable object during each iteration.</li>
    <li>iterable: Represents the iterable object (e.g., array, string, map, set) over which the loop will iterate.</li>
    </ul>
    <h5 className="mt-3"><strong>Array Example</strong></h5>
    <CopyBlock
    language={language}
    text={code12}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    />
    <h5 className="mt-3"><strong>Result</strong></h5>
    <CopyBlock
    language={language}
    text={code13}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    />
    <h5 className="mt-3"><strong>String Example</strong></h5>
    <CopyBlock
    language={language}
    text={code14}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    />
    <h5 className="mt-3"><strong>Result</strong></h5>
    <CopyBlock
    language={language}
    text={code15}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    />
    <p className="mt-3">The for...of loop iterates over the elements of the iterable object and assigns each element to the specified variable (fruit, char, key, value in the examples above) for each iteration. It automatically handles the iteration process and does not require manual index management like traditional for loops or forEach() loops. Additionally, the for...of loop only iterates over the values of iterable objects and does not provide access to the indices directly. If you need access to indices, you may still use traditional for loops or use the entries() method for arrays or the keys() method for other iterable objects.</p>
    </div>

    <div class="alert alert-secondary mt-3" role="alert">
    <h4><strong>Loop Control Statements</strong></h4>
    <p>JavaScript also provides loop control statements to alter the flow of loops</p>
    <ul>
    <li>break: Terminates the loop prematurely.</li>
    <li>continue: Skips the current iteration and proceeds to the next iteration of the loop.</li>
    </ul>
    <CopyBlock
    language={language}
    text={code16}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    />
    </div>

    <div class="alert alert-secondary mt-3" role="alert">
    <h4><strong>Nested Loops</strong></h4>
    <p>You can nest loops within each other to perform more complex iterations.</p>
    <CopyBlock
    language={language}
    text={code17}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    />
    </div>
    <div class="alert alert-secondary mt-3" role="alert">
    <h4><strong>Summary</strong></h4>
    <p>Loops are powerful tools in JavaScript for automating repetitive tasks and iterating over data structures. By understanding the different types of loops and their applications, you can write efficient and concise code to accomplish various programming tasks.</p>
    </div>
    </div>
    </div>
    </div>
    </HTMLCourseNavProvider>
  )
}

export default JavaScriptLesson33
